module.exports = __webpack_public_path__ + "static/media/redo.1b8a8f6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/redo.jpg
// module id = 104
// module chunks = 0